import React from "react";
import LegalPage from "./LegalPage";

export default function Refunds() {
  return <LegalPage pageKey="refunds" testId="refunds-page" />;
}
